import { Acl } from 'phoenix/domain';
import { 
	AuthService, 
	ProgressService
} from 'phoenix/services';
import { CommentsService} from 'sharebase/services/commentsService';
import { DocumentDataStore } from 'sharebase-app/dataStores/documentDataStore';
import { ShareBaseItemComments } from 'phoenix/domain/sharebase-comment';
import { TrackingService } from 'sharebase/services/trackingService/';
import { DocumentDetails } from 'sharebase-app/components/documentDetails/documentDetails';
import { User } from 'sharebase/domain';
require('./comments.styles');
const template = require('./comments.template');
const mobileTemplateUrl = require('./commentsMobile.template.html')

/**
 * @ngdoc directive
 * @name sharebase-app.directive:sbaComments
 * @module sharebase-app
 * @restrict E
 * @description
 *
 * `sbaComments` displays comments of a document
 *
 * @usage
 *
 * <sba-comments document-id="1234" show-comments="true"/> 
 * 
 * @element input
 * @param {integer=} documentId The ID of the document that the comments belong to 
 * 
 * @param {bool=} showComments Determines if comments should be shown or not
 */
export function CommentsDirective(
	$timeout:ng.ITimeoutService,
	$interval:ng.IIntervalService, 
	$mdBottomSheet, 
	$mdMedia, 
	localStorageService,
	pxProgressService:ProgressService
):ng.IDirective {
	return {
		restrict: 'E',
		controller: CommentsController,
		controllerAs: 'vm',
		template,
		bindToController: true,
		scope: {
			documentId: '<',
			showComments: '=?',
			mode: '@',
			userFilter: '=?'
		},
		link: function(scope:any, element, attrs) {
			scope.vm.loadingScrolled = false;
			scope.$watchCollection('vm.comments.Embedded.Comments', function (newVal, oldVal) {
				if (!newVal) { return; }
				if (newVal !== oldVal) { 
					scope.vm.commentsLoaded = true;
					pxProgressService.visible = false;
				}
				else if (newVal === oldVal && scope.vm.mode!=='bottomSheet') { 
					scope.vm.commentsLoaded = false;
				}
				scroll();
			});	

			//show comments
			scope.$watch('vm.showComments', function(newVal) {
				
				if (newVal === undefined || newVal === null) { return; }
				//set user's detail state
				if (scope.vm.mode!=='bottomSheet') {
					localStorageService.setStoredValue('sba-doc-details-second-view', (newVal === true ? 'comments' : ''));
				}
				
				if (!newVal) {
					scope.vm.commentsLoading = false;
					return;
				}

				if (scope.vm.mode==='bottomSheet') {					
					scope.vm.loadingScrolled = false;
				}
				
				scroll();
			});

			function scroll() {
				let i =$interval(() => {
					let scrollElment = document.querySelector('.sba-comments__comment-list');	
					if (scrollElment) {
						$interval.cancel(i);
						$timeout(()=>{								
							scrollElment.scrollTop = scrollElment.scrollHeight;
							scope.vm.loadingScrolled = true;
							scope.vm.commentsLoading = false;
						},300);	
					}
					
				}, 50, 10);
			}
		}
	};
}

CommentsDirective.$inject =  [
	'$timeout',
	'$interval',
	'$mdBottomSheet',
	'$mdMedia',
	'localStorageService',
	'pxProgressService'
];

export class CommentsController {
	public static $inject = [
		'$sce',
		'$mdBottomSheet',
		'$mdMedia',
		'sbaDocumentDataStore',
		'sbCommentsService',
        'sbTrackingService',
		'pxProgressService',
		'pxAuthService',
		'gettextCatalog'
	];

	public userFilter;
	public currentUserAcl:Acl;
	public subs:(() => void)[] = [];
	public uiLoading:boolean = true;
	public you:string = this.gettextCatalog.getString('You');
	public comments:ShareBaseItemComments;
	public media:any = this.$mdMedia;
	public newCommentText:string = this.userFilter ? this.gettextCatalog.getString('Comment @{{userName}}', {userName: this.userFilter.UserName}) : this.gettextCatalog.getString('Add comment, @mention');
	public openCommentText:string = this.gettextCatalog.getString('Click/swipe up for comments');
	public comment:string = '';
	public commentsLoading:boolean = false;
	public showComments:boolean = angular.isDefined(this.showComments) ? this.showComments : false;
	public documentId:number;
	public mode:string;
	public commentsLoaded:boolean = false;
	public get userFilterMessage() {
		if(this.userFilter){
			return this.gettextCatalog.getString('No comments for {{filterName}}', {
				filterName: this.userFilter.UserName
			});
		}
	}

	constructor(
		private $sce:ng.ISCEService,
		private $mdBottomSheet,
		private $mdMedia,
		private sbaDocumentDataStore:DocumentDataStore,
		private sbCommentsService:CommentsService,
		private trackingService:TrackingService,
		private pxProgressService:ProgressService,
		private pxAuthService:AuthService,
		private gettextCatalog:ng.gettext.gettextCatalog
	) {
	
		this.commentsLoading = true;
		this.loadComments()
			.then(comments => {
				this.commentsLoaded = true;
				this.comments = comments;	
			})
			.finally(() => {
				this.commentsLoading = false;				
			});
	}

	private loadComments() {
		let p:ng.IPromise<DocumentDetails>;
		if(!this.documentId){
			throw new Error('Must specify a document ID.');
		}		
		p = this.sbaDocumentDataStore
			.load(this.documentId)
			.then(() => this.sbaDocumentDataStore.getDetails());

		return p.then(details => details.comments);
	}

	public submitComment() {
		if(!this.comment || this.comment ===''){return;}
		
		if(this.userFilter && this.comment.indexOf('[' + this.userFilter.Username + ']') === -1){
			this.comment = '[' + this.userFilter.UserName + '] ' + this.comment;
			this.sbCommentsService.replaceMention(this.comment, '[' + this.userFilter.UserName + ']', this.userFilter);
		}

		let target = this.media('gt-sm') ? 'Desktop View' : 'Mobiel View';
		this.trackingService.trackClick('Comment Added',target);

		this.sbCommentsService
			.postComment(this.comments, this.comment)
			.then(comment => {
				this.comments.Embedded.Comments.push(comment);
				this.comments.TotalComments += 1;
			});
		
		this.comment = '';
	};

	public renderComment(commentText) {
		return this.$sce.trustAsHtml(this.sbCommentsService.toHtml(commentText));
	}

	public openBottomSheet() {
		//track click
		this.trackingService.trackClick('Opened bottom sheet comments','');

		if (!this.commentsLoaded && !this.media('gt-sm')) {
			this.pxProgressService.visible = true;
		}
		this.$mdBottomSheet.show({
			template: mobileTemplateUrl,
			controller: () => this,
			controllerAs: 'vm',
			bindToController: true,
		})
		.then(() => {
			this.showComments = false;
		})
		.catch(() => {
			this.showComments = false;
		});
		this.showComments = true;
	}

	public closeBottomSheet() {
		this.$mdBottomSheet.hide();
	}

	public filterComments = (item)=>{
		if(this.userFilter){
			return item.UserName === this.userFilter.UserName || item.CommentText.indexOf(this.userFilter.UserName + '[/]') > 0 ;
		}
		
		return true;
	}
	
}


// WEBPACK FOOTER //
// ./src/sharebase-app/components/comments/comments.ts